import React, { Component } from "react";
import {
	Row,
	Col,
	Card,
	CardBody,
	Label,
	Input,
	Modal,
	ModalBody,
} from "reactstrap";
import history from "../../history";
import CartTitle from "../../components/CartTitle";
import Loader from "../Loader";
import MaterialTable from "material-table";

import "../../assets/scss/components/MeterialTable/index.scss";
import { helperFunctionForStatus } from "../../utils/helperFunction";

import get from "lodash/get";
import { fetchQueryParams } from "../../utils/comman";
import EventDetail from "../../components/EventDetails";

const _ = { get };

export default class EventList extends Component {
	constructor(props) {
		super(props);

		this.state = {
			status: "PENDING",
			toggleModal: false,
			selectedId: "",
		};
	}

	componentDidMount() {
		let queryParams = this.props.query;
		const params = fetchQueryParams(queryParams);
		console.log("par", params);
		if (
			Object.keys(params).length > 0 &&
			params.status !== "" &&
			params.status != "undefined"
		) {
			let newState = { ...this.state };
			newState.status = params.status;
			this.setState({ ...newState });

			if (this.props.page !== "moderation") {
				this.props.handleFetchAllEvent();
			} else {
				this.props.handleFetchEventsForModeration(params.status);
			}
		} else {
			if (this.props.page !== "moderation") {
				this.props.handleFetchAllEvent();
			} else {
				this.props.handleFetchEventsForModeration(this.state.status);
			}
		}
	}

	handleToggleModel = (e) => {
		let newState = { ...this.state };
		newState.toggleModal = !newState.toggleModal;
		this.setState({ ...newState });
	};

	handleRowData = (data) => {
		let newState = { ...this.state };
		newState.selectedId = data._id;
		newState.toggleModal = !newState.toggleModal;
		this.setState({ ...newState });
	};

	handleChangeStatus = (e) => {
		{
			this.props.page === "moderation"
				? history.replace("/event/moderation")
				: history.replace("/event/list");
		}
		let state = this.state;
		state.status = e.target.value;
		this.setState({ ...state });
		this.props.handleFetchEventsForModeration(this.state.status);
	};

	render() {
		let { elements } = this.props;

		console.log("status", this.state);
		return (
			<div className="userListing hideSearch">
				{this.props.page !== "moderation" ? (
					this.props.allEventsStatus !== false ? (
						<Loader />
					) : null
				) : this.props.eventForModerationStatus !== false ? (
					<Loader />
				) : null}

				<Row>
					<Col sm={12}>
						<CartTitle
							title={_.get(
								elements,
								"eventListTableElement.headingElement",
								"Event"
							)}
							Name={"Search"}
							customClass={"hidebtn"}
							iconClass={"hideexcel"}
							innerTextClass={"hidetext"}
						/>
					</Col>
					{this.props.page === "moderation" ? (
						<Col sm={12}>
							<Card className="mb-3">
								<CardBody>
									<Row>
										<Col lg={5}>
											<Label className="inputLabel">
												{_.get(
													elements,
													"eventListTableElement.statusLabelElement",
													"Status"
												)}
											</Label>
											<Input
												type="select"
												name="City"
												value={this.state.status}
												className="w-100 customeSelectBtn my-2"
												onChange={
													this.handleChangeStatus
												}
											>
												<option value={"PENDING"}>
													{_.get(
														elements,
														"eventListTableElement.pendingElement",
														"Pending"
													)}
												</option>
												<option value={"APPROVED"}>
													{_.get(
														elements,
														"eventListTableElement.approvedElement",
														"Approved"
													)}
												</option>
												<option value={"REJECTED"}>
													{_.get(
														elements,
														"eventListTableElement.rejectedElement",
														"Rejected"
													)}
												</option>
											</Input>
										</Col>
									</Row>
								</CardBody>
							</Card>
						</Col>
					) : null}
				</Row>
				<Row>
					<Col sm="12">
						<div className="custom-m-table">
							<MaterialTable
								title=""
								columns={[
									{
										title: _.get(
											elements,
											"eventListTableElement.eventNameElement",
											"Event Name"
										),
										field: "eventName",
									},
									{
										title: _.get(
											elements,
											"eventListTableElement.eventLocationElement",
											"Event Location"
										),
										field: "eventLocation",
									},
									{
										title: _.get(
											elements,
											"eventListTableElement.moderationStatusElement",
											"Moderation Status"
										),
										field: "moderationStatus",
										render: (rowData) =>
											helperFunctionForStatus(
												rowData.moderationStatus,
												elements
											),
									},
									{
										title: _.get(
											elements,
											"eventListTableElement.branchNameElement",
											"Branch Name"
										),
										field: "createdBy.branchName",
									},
									{
										title: _.get(
											elements,
											"eventListTableElement.countryNameElement",
											"Country Name"
										),
										field: "eventInfo.country",
									},
									{
										title: _.get(
											elements,
											"eventListTableElement.statsElement",
											"State"
										),
										field: "eventInfo.state",
									},
									{
										title: _.get(
											elements,
											"eventListTableElement.cityElement",
											"City"
										),
										field: "eventInfo.city",
									},
								]}
								data={
									this.props.page !== "moderation"
										? this.props.allEvents
										: this.props.eventForModeration
								}
								options={{
									actionsColumnIndex: -1,
									search: false,
									paging: true,
									sorting: false,
									pageSize: 10,
								}}
								actions={[
									{
										icon: "assignment_ind",
										tooltip: "Detail Page",
										onClick: (event, rowData) =>
											this.handleRowData(rowData),
									},
								]}
								localization={{
									body: {
										emptyDataSourceMessage: (
											<h6>
												{_.get(
													elements,
													"eventListTableElement.noRecordsFoundElement",
													"No records to display"
												)}
											</h6>
										),
									},
									// pagination: {
									//   labelRowsSelect: _.get(
									//     elements,
									//     "customMaterialTableElement.labelRowsSelect", "rows"
									//   ),
									//   previousTooltip: _.get(
									//     elements,
									//     "customMaterialTableElement.previousTooltip", "previous"
									//   ),
									//   nextTooltip: _.get(
									//     elements,
									//     "customMaterialTableElement.nextTooltip", "next"
									//   ),
									// },
									header: {
										actions: _.get(
											elements,
											"eventListTableElement.actionsElement",
											"Actions"
										),
									},
								}}
							/>
						</div>
					</Col>
				</Row>
				<Modal
					isOpen={this.state.toggleModal}
					toggle={this.handleToggleModel}
					backdrop={true}
					centered={true}
					className="modal_main"
					size="xl"
				>
					<ModalBody className="modalBody">
						<EventDetail
							page={this.props.page}
							allEvents={this.props.allEvents}
							allEventsStatus={this.props.allEventsStatus}
							handleFetchAllEvent={this.props.handleFetchAllEvent}
							handleFetchSingleEvent={
								this.props.handleFetchSingleEvent
							}
							elements={this.props.elements}
							singleEvent={this.props.singleEvent}
							singleEventStatus={this.props.singleEventStatus}
							query={this.props.query}
							allUser={this.props.allUser}
							allUserStatus={this.props.allUserStatus}
							handleEventGallery={this.props.handleEventGallery}
							handleUsersForJoinEvent={
								this.props.handleUsersForJoinEvent
							}
							handleUsersModerationForJoinEvent={
								this.props.handleUsersModerationForJoinEvent
							}
							handleClearPreviousReducer={
								this.props.handleClearPreviousReducer
							}
							handleEventModeration={
								this.props.handleEventModeration
							}
							handleFetchAllUser={this.props.handleFetchAllUser}
							handleJoinUser={this.props.handleJoinUser}
							usersToJoinEventStatus={
								this.props.usersToJoinEventStatus
							}
							usersToJoinEvent={this.props.usersToJoinEvent}
							moderationStatusForUser={
								this.props.moderationStatusForUser
							}
							moderateEventGalleryStatus={
								this.props.moderateEventGalleryStatus
							}
							selectedId={this.state.selectedId}
							status={this.state.status}
							handleToggleModel={this.handleToggleModel}
						/>
					</ModalBody>
				</Modal>
			</div>
		);
	}
}
